import { render, staticRenderFns } from "./pionts_rule_config.vue?vue&type=template&id=1a5a8e1b"
import script from "./pionts_rule_config.vue?vue&type=script&lang=js"
export * from "./pionts_rule_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports